import { PlayerContextState } from "../../../PlayerContext";
import { createChestEvent } from "../../../events/campus/Chest";
import HealthPotion from "../../../items/consumable/HealthPotion";
import glaive from "../../../items/equipment/hand/Glaive";
import scimitar from "../../../items/equipment/hand/Scimitar";
import BatWing from "../../../items/other/BatWing";
import RatTail from "../../../items/other/RatTail";
import { Dungeon } from "../Dungeon";
import { DungeonFloor } from "../DungeonFloor";
import SchoolBasementB1 from "./SchoolBasementB1";
import SchoolBasementB2 from "./SchoolBasementB2";
import SchoolBasementB3 from "./SchoolBasementB3";

class SchoolBasement extends Dungeon {
  getId(): string {
    return "schoolBasement";
  }

  getName(): string {
    return "School Basement";
  }

  getDungeonFloors(): DungeonFloor[] {
    return [SchoolBasementB1, SchoolBasementB2, SchoolBasementB3];
  }

  isUnlocked(state: PlayerContextState): boolean {
    return true;
  }
}

createChestEvent(
  "school_basement_chest_basic",
  [
    SchoolBasementB1.getId(),
    SchoolBasementB2.getId(),
    SchoolBasementB3.getId(),
  ],
  80,
  [
    { itemOccurrence: { itemId: RatTail.getId(), params: {} }, amount: 10 },
    { itemOccurrence: { itemId: BatWing.getId(), params: {} }, amount: 10 },
  ],
);

createChestEvent(
  "school_basement_chest_rarer",
  [SchoolBasementB1.getId(), SchoolBasementB2.getId()],
  50,
  [{ itemOccurrence: { itemId: HealthPotion.getId(), params: {} }, amount: 2 }],
);

createChestEvent("school_basement_chest_rare", [SchoolBasementB3.getId()], 10, [
  { itemOccurrence: { itemId: scimitar.getId(), params: {} }, amount: 1 },
]);

createChestEvent(
  "school_basement_chest_rare2",
  [SchoolBasementB3.getId()],
  10,
  [{ itemOccurrence: { itemId: glaive.getId(), params: {} }, amount: 1 }],
);

export default new SchoolBasement();
